import { useParams, Navigate, Link } from 'react-router-dom';
import { getLegalDoc, LEGAL_SLUGS } from '@/modules/legal/legalContent';
import { ROUTES } from '@/config/routes';

/**
 * B4 · Public legal document page (/legal/:doc). Reachable without auth or the
 * age-gate (landing, login/signup and legal pages stay open). Neon Noir.
 */
export const LegalPage = () => {
  const { doc } = useParams();
  const legal = getLegalDoc(doc);
  if (!legal) return <Navigate to={ROUTES.landing} replace />;

  return (
    <div className="min-h-[100dvh] bg-[#050608] px-6 py-12 text-white">
      <div className="mx-auto max-w-[680px]">
        <Link to={ROUTES.landing} className="font-display text-lg font-extrabold tracking-tight">
          HOTTR<span className="text-[#FF0CB6]">.</span>
        </Link>

        <h1 className="mt-8 font-display text-3xl font-extrabold uppercase tracking-tight">
          {legal.title}
        </h1>
        <p className="mt-1 text-xs text-white/40">Last updated {legal.updated}</p>

        {legal.draft && (
          <p className="mt-4 rounded-[2px] border border-[#FF0CB6]/40 bg-[#FF0CB6]/10 px-3 py-2 text-xs text-[#FF0CB6]">
            Draft — pending legal counsel review before launch.
          </p>
        )}

        <div className="mt-8 space-y-6">
          {legal.sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-display text-sm font-bold uppercase tracking-wide text-white">
                {s.heading}
              </h2>
              <p className="mt-1.5 text-sm leading-relaxed text-white/70">{s.body}</p>
            </section>
          ))}
        </div>

        <nav className="mt-12 flex flex-wrap gap-x-4 gap-y-2 border-t border-white/10 pt-6 text-xs text-white/50">
          {LEGAL_SLUGS.map((slug) => (
            <Link key={slug} to={ROUTES.legal(slug)} className="capitalize hover:text-[#FF0CB6]">
              {slug.replace('-', ' ')}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};
